import { useTranslation } from "react-i18next";
import InputText from "../../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { classNames } from "../../../utils/helpers";
import Footer from "../../../components/footer/component";
import { currentDomain } from "../../../utils/general-config";
import { DomainName } from "../../../utils/constants";
const PSRForgetPassword = ({ emailError, emailSuccess, email, onemailChange, onSubmitClickHandler, emailErrorMsg }) => {
  console.log("PSRForgetPassword rendered", emailErrorMsg);
  const { t } = useTranslation();
  let Domain = currentDomain().toLowerCase();
  return (
    <>
      <Helmet>
        <meta name="description" content={t("forgot_password.ps.description_meta")} />
        <title>
          {Domain === DomainName.PDFSIMPLI ? t("page_title.ps.forgot_password") : t("page_title.ws.forgot_password")}
        </title>
      </Helmet>
      <div className="backdrop-blur-[100px] bg-blur-bg-rs">
        <section className="main-content !min-h-[calc(100vh-9.7rem)] md-!pt-[40px]">
          <div className="container mx-auto">
            <div className="form-wrap-psr !mt-[1rem] !mb-6rem relative p-[2px] rounded-tl-[14px] rounded-tr-[14px] rounded-bl-[50px] rounded-br-[50px] bg-rs-border-gradient">
              <div className="rounded-tl-[14px] rounded-tr-[14px] rounded-bl-[50px] rounded-br-[50px] py-8 px-4 bg-white shadow-md">
                <div className="form-wrap font-rethink">
                  <div className="form-container">
                    <hgroup className="text-center user-page">
                      {!emailSuccess ? (
                        <div>
                          <h1 className="text-[#16283D] font-poppins text-2xl md:text-4xl font-bold md:font-bold mt-0">
                            {t("forgot_password.ps.headline")}
                          </h1>

                          <p className="form-signin-heading text-center text-[#16283D]  font-semibold text-base md:text-lg my-4">
                            {t("forgot_password.ps.content").replace("Provide", "provide")}
                          </p>
                          <p className="text-sm md:text-base font-normal mb-6 max-[370px]:text-[13px]">
                            {t("forgot_password.send_reset_link")}
                          </p>
                        </div>
                      ) : (
                        <div className="-mt-6">
                          <div className="bg-white ml-[2px] rounded-l-lg flex items-center justify-center">
                            <img
                              src={process.env.PUBLIC_URL + "/static/images/worksimpli/check-email-logo.png"}
                              height="55"
                              width="55"
                              className=""
                              alt="Check Email Logo"
                            />
                          </div>
                          <p className="text-2xl md:text-4xl font-bold md:font-extrabold text-[#16283D] my-6">
                            {t("forgot_password.check_your_email")}
                          </p>
                          <p className="font-semibold text-base md:text-lg text-[#16283D] mb-6">
                            {t("forgot_password.didnt_receive_email")}
                          </p>
                          <p className="text-sm font-normal text-[#16283D] mb-6 max-[370px]:text-[13px]">
                            {t("forgot_password.re_enter_email")} <br /> {t("forgot_password.we_send_password")}
                          </p>
                        </div>
                      )}
                    </hgroup>
                    <div className="form-group text-center">
                      <div className="form-text mb-2">
                        {emailError && (
                          <p key="pswrdErr" role={alert} className="alert error  text-red-600 ">
                            <p className="text-sm"> {emailErrorMsg}</p>
                          </p>
                        )}
                      </div>
                      <div>
                        <InputText
                          showLabel={false}
                          required="required"
                          id="email"
                          type="email"
                          className={classNames(
                            emailError ? " border-red-400 rounded p-3 border " : "",
                            "border-gray-300 rounded p-3 border mb-8 max-w-96 text-sm  !font-rethink"
                          )}
                          name="email"
                          value={email}
                          maxLength={100}
                          onChange={onemailChange}
                          placeholder={t("sign_up.ps.placeholder_email")}
                        />
                      </div>
                    </div>
                    <div className=" fbn bounce-effect md:relative bottom-0 left-0 bg-white  border-gray-300 p-2 md:p-0 lg:p-0 text-center w-full  z-50">
                      <button
                        id="forget-password-btn"
                        className="text-white p-4 w-full leading-[120%] !font-rethink tracking-[2%] text-xs md:text-xl font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase transition-colors duration-1000 ease-in-out"
                        isLoading={false}
                        disabled={false}
                        type="submit"
                        onClick={onSubmitClickHandler}
                      >
                        {t("forgot_password.email_reset")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
export default PSRForgetPassword;
